import type { VehicleOrdersState } from '../../../common/models/vehicleOrdersSlice.model';
import { vehicleOrdersAdapter } from './vehicleOrdersSlice.adapters';

export const INITIAL_VEHICLE_ORDERS_STATE =
  vehicleOrdersAdapter.getInitialState<VehicleOrdersState>({
    sessionConfigs: {},
  });
